/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Header from './sub_components/main/header'
import Footer from './sub_components/main/footer'
let markets = [
  {
      "MarketId": "5f07391ef706a607479beadf",
      "MarketStatus": "CLOSED",
      "IsResultDeclared": true,
      "Pnl": 98,
      "Exposure": 0
  },
  {
      "MarketId": "5f07f61e7f11877a8fda44b7",
      "MarketStatus": "CLOSED",
      "IsResultDeclared": true,
      "Pnl": -202,
      "Exposure": 0
  },
  {
      "MarketId": "5f07f7543b603752cff12775",
      "MarketStatus": "CLOSED",
      "IsResultDeclared": true,
      "Pnl": -391,
      "Exposure": 0
  },
  {
      "MarketId": "5f07faa6f522024f93000ca7",
      "MarketStatus": "CLOSED",
      "IsResultDeclared": true,
      "Pnl": 41,
      "Exposure": 0
  },
  {
      "MarketId": "5f080dd17f11877a8fda8cd2",
      "MarketStatus": "CLOSED",
      "IsResultDeclared": true,
      "Pnl": -140.99999999999999,
      "Exposure": 0
  },
  {
      "MarketId": "5f081016f522024f93004a7f",
      "MarketStatus": "OPEN",
      "IsResultDeclared": false,
      "Pnl": 0,
      "Exposure": -108
  },
  {
      "MarketId": "5f08117ef706a607479e2ca3",
      "MarketStatus": "CLOSED",
      "IsResultDeclared": true,
      "Pnl": -1340,
      "Exposure": 0
  },
  {
      "MarketId": "5f0812f0f706a607479e30cb",
      "MarketStatus": "CLOSED",
      "IsResultDeclared": true,
      "Pnl": 851,
      "Exposure": 0
  }
]
class Auth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      passcode: "",
      pageLimit: 10,
      pageActive: 1,
      market_results:markets
    };
  }  
  render() {
    let pages = []
      for (let i = 0; i < (Math.floor(this.state.market_results.length / this.state.pageLimit) + 1); i++) {
         pages.push(<li className={this.state.pageActive === i + 1 ? "paginate_button page-item active" : "paginate_button page-item"} onClick={() => { this.setState({ pageActive: i + 1 }) }}><a aria-controls="example" data-dt-idx="1" tabindex="0" className="page-link">{i + 1}</a></li>)
      }
    return (
      <body className="bethubs">
        <Header history = {this.props.history} />
        <div className="wrapper">
          <div className="w3-sidebar w3-bar-block w3-border-right" style={{ "display": "none" }} id="mySidebar">
            <button onclick="w3_close()" className="w3-bar-item w3-large bg-hover">Close &times;</button>
            <ul>
              <li><a href="list-of-clients.html">List of Clients</a></li>
              <li><a href="#">Market Analysis</a></li>
              <li><a href="import-event.html">Import Event</a></li>
              <li>
                <a href="#homeSubmenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Live Markets </a>
                <ul className="list-unstyled collapse" id="homeSubmenu" >
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
              <li>
                <a href="#home1Submenu" data-toggle="collapse" aria-expanded="true" className="dropdown-toggle"> Reports</a>
                <ul className="list-unstyled collapse" id="home1Submenu" >
                  <li><a href="#">Test 1</a></li>
                  <li><a href="#">Test 1</a></li>
                </ul>
              </li>
            </ul>
          </div>
          <div className="container-fluid container-padding-0">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="main-box">
                  <div>
                    <h5 className="text-blue  mb-4">
                    <span className="text-red ">This is only Layout Design of Page.</span>
                    <br /><br />
                      <span>Market Results</span>
                    </h5>
                  </div>
                  <div className="row mt-1">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 table-responsive">
                      {this.state.market_results.length > 0 ? <table id="example" className="table table-striped table-bordered font-12 table-sm" style={{ width: "100%" }}>
                        <thead>
                          <tr>
                            <th>No.</th>
                            <th>Market</th>
                            <th>Market Status</th>
                            <th>Result Status</th>
                            <th>P/L</th>
                            <th>Exposure</th>
                          </tr>
                        </thead>
                        <tbody>
                          {this.state.market_results.map((mkt, i) => {
                            return (<>{i < (this.state.pageLimit * this.state.pageActive) && (i + 1) > (this.state.pageLimit * (this.state.pageActive - 1)) && <tr>
                              <td><span>{i+1}</span></td>
                              <td><span>{mkt.MarketId}</span></td>
                              <td><span>{mkt.MarketStatus}</span></td>
                              <td><span>{mkt.IsResultDeclared?"Declared":"Not Declared"}</span></td>
                              <td><span>{mkt.Pnl}</span></td>
                              <td><span>{mkt.Exposure}</span></td>                              
                            </tr>}</>
                            )
                          })}
                        </tbody>
                      </table> :
                        <span>No account found under your account.</span>
                      }
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12 col-md-5">
                      <div className="dataTables_info" id="example_info" role="status" aria-live="polite">Showing {(this.state.pageLimit * (this.state.pageActive - 1)) + 1} to {(this.state.pageLimit * this.state.pageActive) < this.state.market_results.length ? (this.state.pageLimit * this.state.pageActive) : this.state.market_results.length} of {this.state.market_results.length} entries</div>
                    </div>
                    <div className="col-sm-12 col-md-7">
                      <div className="dataTables_paginate paging_simple_numbers" id="example_paginate">
                        <ul className="pagination">
                          <li className={this.state.pageActive === 1 ? "paginate_button page-item previous " : "paginate_button page-item previous disabled"} onClick={() => { if (this.state.pageActive > 1) { this.setState({ pageActive: (this.state.pageActive - 1) }) } }} id="example_previous"><a aria-controls="example" data-dt-idx="0" tabindex="0" className="page-link">Previous</a></li>
                          {
                            pages
                          }
                          <li className={this.state.pageActive === Math.floor(this.state.market_results.length / this.state.pageLimit) ? "paginate_button page-item next disabled" : "paginate_button page-item next "} onClick={() => { if (this.state.pageActive === Math.floor(this.state.market_results.length / this.state.pageLimit)) { this.setState({ pageActive: (this.state.pageActive + 1) }) } }} id="example_next"><a aria-controls="example" data-dt-idx="2" tabindex="0" className="page-link">Next</a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </body>

    )
  }
}
function mapStateToProps(state) {
  return {
  };
}
function mapDispatchToProps(dispatch) {
  return {
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(Auth);